import React, {useEffect, useState} from "react";
import './Cabinet.css';
import closeAuth from "../../../../static/img/Header/closeAuth.svg";
import IconsSiteFxBTC51 from "../../../../static/img/SVG/IconsSiteFxBTC51.svg";
import exitblack from "../../../../static/img/Header/exitblack.svg";
import axios from "axios";
import ChangeLink from "../../../../Elements/ChangeLink/ChangeLink";
const PRERENDER_TEXTS = require("../../../../../prerender_base.js");

function CabinetHeader(props) {
    function TextSource(info) {try { return <>{JSON.parse(PRERENDER_TEXTS['CabinetHeader'][info.ArrIndex])[props.lang] ? JSON.parse(PRERENDER_TEXTS['CabinetHeader'][info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    const [VisibleCabinet, setVisibleCabinet] = useState(false);
    const [userData, setUserData] = useState('');

    //console.log('CabinetHeader',PRERENDER_TEXTS['CabinetHeader']);

    function ChangeCabinetVisible() {setVisibleCabinet(!VisibleCabinet);}

    function ExitCabinet() {
        window.location.href = 'https://my.fxbitcoin.org/?hash=none&redirect=' + window.location.href;
    };

    useEffect(() => {
        axios
            .get('https://my.fxbitcoin.org/api/ajax/account/login-data', {withCredentials: true})
            .then((userData) => {
                    setUserData(userData.data);
                }
            )
            .catch(e => console.log(e));
    }, []);

        let EnterCabinet;
        let MainPart;
        if (userData) {EnterCabinet =
            <div className="ButtonTransparency ButtonTransparencyIn EnterCabinet" >

                <img alt='alt' className="ButtonTransparencyInImg" src={IconsSiteFxBTC51} height="19" width="17"/>
                <nobr>{(userData.Email.length > 25) ? (userData.Email.slice(0,20)+'...') : userData.Email}</nobr>
                <div className="ButtonTransparencyInImgExit" onClick={ExitCabinet} role="button" tabIndex={0} onKeyPress={() => {}} ><img alt='alt' className="ButtonTransparencyInImgExitIMG" src={exitblack} height="16"/></div>
            </div>
        } else {
            if (VisibleCabinet) {
                EnterCabinet =
                    <div className="for_cabOut" >
                        <div className="for_cab"  onClick={ChangeCabinetVisible} role="button" tabIndex={0} onKeyPress={() => {}}> </div>
                        <div className="cab_in">
                            <iframe src={"https://my.fxbitcoin.org/iframe/account/login/?lang"+props.lang} title="Login"
                                    name="login" className="autoHeight-iframe" frameBorder="0" width="330px" height="360px"/>
                            <div className="iFrameCabinetCrest"><img alt='Ifyoudontseeimages' src={closeAuth} width="16px" height="16px"/></div>
                            <div className="iFrameCabinetLinks">
                                <div className="iFrameCabinetLinksElement"><ChangeLink lang={props.lang} to='/trader/open/' ><TextSource ArrIndex= 'CabinetHeader0005'>Регистрация</TextSource></ChangeLink></div>
                                <div className="iFrameCabinetLinksElement"><ChangeLink lang={props.lang} to='/trader/recoverypassword' ><TextSource ArrIndex= 'CabinetHeader0010'>Забыли пароль?</TextSource></ChangeLink></div>
                            </div>
                        </div>
                    </div>
            }
            else {EnterCabinet = <div className="ButtonTransparency ButtonTransparencyIn" ><img alt='alt' className="ButtonTransparencyInImg" src={IconsSiteFxBTC51} height="19" width="17"/><nobr><TextSource ArrIndex= 'CabinetHeader0000'>Войти</TextSource></nobr></div>
            }
        }

        if (props.Phone) { MainPart = <div className="phonePart" onClick={ChangeCabinetVisible} role="button" tabIndex={0} onKeyPress={() => {}}><img alt='Ifyoudontseeimages'
                                                                                                                                                                           src={IconsSiteFxBTC51} width="19" height="23"/>{EnterCabinet}</div>
        } else {
            MainPart = <div className="header_key" onClick={ChangeCabinetVisible} role="button" tabIndex={0} onKeyPress={() => {}}>

                {EnterCabinet}
            </div>
        }
        return (<div className="header_keyOut">{MainPart}</div>)}

export default CabinetHeader